module.exports = __webpack_public_path__ + "static/mobile-app-a78d7fe64247cb910cd01c8697fafb8b.jpg";